export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  isSaving: (state) => state.isSaving,
  edd: (state) => state.edd,
  questionnaire: (state) => state.questionnaire,
  states: (state) => state.states,
};
